//---------------------------------------------------------------------------
// ストアページトップ
//---------------------------------------------------------------------------
var StoreTop = Backbone.View.extend({
	events:{
		"click #keiyakun_get_data_button":"onClickKeiyakunButton", // けいやくんからデータ取得のボタン
		"click #contract_create_keiyakun_btn" : "onClickInitialGetKeiyakunModal",
	},



	initialize:function(){
		console.log('StoreTop');
	},


/*=============================
=            Event            =
=============================*/

	onClickInitialGetKeiyakunModal:function(){
		$('#keiyakun_request_box').hide();
		$('#keiyakun_error_box').hide();
		$('#keiyakun_has_box').hide();
	},

	onClickKeiyakunButton:function(e){
		e.preventDefault();

		var keiyakun_id = $('#keiyakun_id').val();

		if(keiyakun_id){

			var post = {};
			post.id = keiyakun_id;

			$('#keiyakun_modal_body').waitMe({effect : 'progressBar'});
			$('#keiyakun_request_box').hide();
			$('#keiyakun_error_box').hide();
			$('#keiyakun_has_box').hide();

			this.ajax(__AJAX_KEIYAKUN_URL,post,function(res){
				if(res.http_code === 200){
					var name = res.customer.name_sei + " " + res.customer.name_mei + "（" + res.customer.kana_sei + " " + res.customer.kana_mei + "）";
					$('#keiyakun_id_span').text(res.no);
					$('#keiyakun_name_span').text(name);
					$('#keiyakun_price_span').text(changeNumFomatMoney(Number(res.total_amount)));
					var url = $("#contract_keiyakun_create_btn").data('href') + "?keiyakun=" + res.hash;
					$("#contract_keiyakun_create_btn").attr('href',url);
					$('#keiyakun_request_box').show();
				}else if(res.http_code === 201){
					$('#keiyakun_has_box').show();
				}else{
					$('#keiyakun_error_box').show();
				}
				$('#keiyakun_modal_body').waitMe('hide');
				
			});
		}
	},

/*=====  End of Event  ======*/


});